"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXISTING_OFFLINE_ORDER = void 0;

var _existingOfflineOrder = require("./existingOfflineOrder");

var _selectProducts = require("./selectProducts");

var _overview = require("./overview");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EXISTING_OFFLINE_ORDER = _objectSpread(_objectSpread({}, _existingOfflineOrder.EXISTING_OFFLINE_ORDER), {}, {
  SELECT_PRODUCTS: _selectProducts.SELECT_PRODUCTS,
  OVERVIEW: _overview.OVERVIEW
});

exports.EXISTING_OFFLINE_ORDER = EXISTING_OFFLINE_ORDER;